/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DialogBannerComponent } from '@src/app/shared/dialogs/dialog-banner-component';
import { ErrorLogEntry } from './error-logs-dialog.component';

export interface ErrorLogDetailDialogData {
    error: ErrorLogEntry;
}

@Component({
    selector: 'app-error-log-detail-dialog',
    templateUrl: './error-log-detail-dialog.component.html',
    styleUrls: ['./error-log-detail-dialog.component.scss'],
    imports: [DialogBannerComponent, MatDialogContent, MatIconModule]
})
export class ErrorLogDetailDialogComponent {
    dialogRef = inject<MatDialogRef<ErrorLogDetailDialogComponent>>(MatDialogRef);
    data = inject<ErrorLogDetailDialogData>(MAT_DIALOG_DATA);

    error: ErrorLogEntry = this.data.error;
}
